import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterVaccin'
})
export class FilterVaccinPipe implements PipeTransform {

  transform(items: any[], searchText: string): any[] {
    if (!items) {
      return [];
    }
    if (!searchText) {
      return items;
    }
    searchText = searchText.toLowerCase();
    return items.filter(item => {
      return (item.nom_Labo_Vaccin.toLowerCase().includes(searchText) || item.nom_Vaccin.toLowerCase().includes(searchText)  || item.nom_commercial_Vaccin.toLowerCase().includes(searchText) );

    });
    
  }

}
